import color from 'color';
import {createUseStyles, useTheme} from 'react-jss';
import Translation from '../../../../v2/lang/Translation';
import MediaQueries from '../../../../v2/style-helper/MediaQueries';
import SecurityIcon from '../SecurityIcon';

// Sets text colour based on header background colour
const setTextColor = colorVal => (color(colorVal).isLight() ? '#333' : '#fff');

const useStyles = createUseStyles({
  textContainer: {
    [MediaQueries.tablet]: {
      display: 'inline',
    },
  },
  
  securityCertText: {
    fontSize: 12,
    verticalAlign: 'middle',
    lineHeight: 1,
    color: props => setTextColor(props.theme.header.backgroundColour),
    
    [MediaQueries.phone]: {
      color: props => setTextColor(props.theme.header.mobileBackgroundColour || props.theme.header.backgroundColour),
    },
  },
});

export function DefaultSecurityCert(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <>
      <SecurityIcon />
      <div className={classes.textContainer}>
        <span className={classes.securityCertText} data-test="SecurityCertificate__text">
          <Translation>secure.checkout</Translation>
        </span>
      </div>
    </>
  );
}

export default DefaultSecurityCert;
